export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[580px] md:min-h-[640px] flex items-center bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新 · 每日爆料
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[56px] font-heading text-foreground-950 leading-tight mb-4">
              51每日大赛
              <span className="block text-primary-600">全网吃瓜爆料第一站</span>
            </h1>

            <p className="text-lg md:text-xl text-primary-600/80 font-medium mb-5">
              每日更新最热娱乐八卦与争议事件，吃瓜爱好者的一站式爆料平台
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              51每日大赛是国内领先的娱乐八卦与争议事件聚合平台，每日精选全网最热吃瓜内容，涵盖明星塌房、综艺争议、网红翻车、影视吐槽等热门话题。我们以多源验证、快速响应为原则，为吃瓜群众提供最新、最全、最真实的娱乐爆料资讯。无论你是资深八卦爱好者还是偶尔围观的吃瓜路人，这里都有你想要的精彩内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="text-accent-600 font-bold text-lg">200+</span>
                <span>每日更新爆料</span>
              </div>
              <div className="w-px h-5 bg-foreground-300 hidden sm:block"></div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="text-accent-600 font-bold text-lg">500万+</span>
                <span>月活跃吃瓜群众</span>
              </div>
              <div className="w-px h-5 bg-foreground-300 hidden sm:block"></div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-shield-check-line text-accent-600 text-lg"></i>
                <span>信源交叉验证</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#index')}
                className="w-full sm:w-auto px-8 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => scrollTo('#contact')}
                className="w-full sm:w-auto px-8 py-3.5 rounded-md border-2 border-foreground-300 text-foreground-700 font-semibold text-base hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                投稿爆料
                <i className="ri-send-plane-line ml-2"></i>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none flex justify-center">
            <div className="relative w-full max-w-[420px] aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20stylized%20illustration%20of%20entertainment%20news%20and%20gossip%20culture%2C%20colorful%20speech%20bubbles%20floating%20around%20magazine%20covers%2C%20hot%20topic%20badges%20in%20warm%20red%20and%20gold%20tones%2C%20modern%20pop%20art%20style%20with%20bold%20graphic%20elements%2C%20clean%20cream%20background%20with%20subtle%20texture%2C%20editorial%20design%20aesthetic%2C%20energetic%20composition%20with%20dynamic%20layout&width=840&height=630&seq=hero-gossip-01&orientation=landscape"
                alt="51每日大赛 - 娱乐八卦爆料平台主视觉"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}